// app/not-found.js
// Global 404. Several portal features (Maps, Message Board, Weather, Analytics,
// The List, Training Calendar, Board Finder) are still being migrated from the
// Blazor app and have no route yet — this gives those links a branded, readable
// landing instead of the raw Next.js "page could not be found" error.
'use client';

import Link from 'next/link';
import { FaTools, FaHome } from 'react-icons/fa';

export default function NotFound() {
    return (
        <div className="page-container">
            <div className="max-w-lg mx-auto mt-8 sm:mt-16">
                <div className="card p-6 sm:p-8 text-center space-y-4">
                    <div className="w-16 h-16 rounded-xl bg-gray-100 flex items-center justify-center mx-auto">
                        <FaTools className="w-7 h-7 text-gray-400" />
                    </div>

                    <div>
                        <h3 className="text-gray-900">Page Not Available</h3>
                        <p className="text-sm text-gray-500 mt-1">This page doesn&apos;t exist yet</p>
                    </div>

                    <p className="text-sm text-gray-600">
                        Some portal features are still being migrated to the new site.
                        If you followed a link from the menu, that section is on the way —
                        check back soon.
                    </p>

                    <div className="pt-2">
                        <Link href="/" className="btn btn-primary inline-flex items-center gap-2">
                            <FaHome className="w-3.5 h-3.5" /> Back to Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
